import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logoImage from '../img/logo.png';
import { useAuthContext } from '../context/AuthContext';

const Login = () => {
  const [email,     setEmail]     = useState('');
  const [password,  setPassword]  = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error,     setError]     = useState(null);
  const [showPass,  setShowPass]  = useState(false);
  const { login } = useAuthContext();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      const loginData = await login(email, password);

      if (loginData) {
        if (loginData.onboarding && !loginData.onboarding.complete) {
          navigate(
            loginData.onboarding.step
              ? `/onboarding/${loginData.onboarding.step.replace('pending_', '')}`
              : '/onboarding/materials',
            { replace: true }
          );
        } else {
          navigate('/app', { replace: true });
        }
      } else {
        setError('Falha ao processar o login. Tente novamente.');
      }
    } catch (err) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else if (err.request) {
        setError('Não foi possível conectar ao servidor. Verifique sua conexão.');
      } else {
        setError('Ocorreu um erro ao tentar fazer login. Tente novamente.');
      }
      console.error('Erro no login:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      fontFamily: "'Inter', 'Segoe UI', sans-serif",
      backgroundColor: '#f8fafc',
    }}>

      {/* ── Painel esquerdo — decorativo ── */}
      <div style={{
        display: 'none',
        flex: 1,
        background: 'linear-gradient(145deg, #1e3a5f 0%, #1e40af 45%, #3b82f6 100%)',
        padding: '48px',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'relative',
        overflow: 'hidden',
      }}
        className="login-left-panel"
      >
        {/* Círculos decorativos */}
        <div style={{ position: 'absolute', top: '-80px', right: '-80px', width: '300px', height: '300px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.05)' }} />
        <div style={{ position: 'absolute', bottom: '-60px', left: '-60px', width: '250px', height: '250px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.04)' }} />
        <div style={{ position: 'absolute', top: '40%', right: '10%', width: '120px', height: '120px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.04)' }} />

        {/* Logo no painel esquerdo */}
        <div>
          <img src={logoImage} alt="Logo" style={{ maxHeight: '48px', opacity: 0.9 }} />
        </div>

        {/* Texto central */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h2 style={{ color: '#fff', fontSize: '32px', fontWeight: '700', lineHeight: '1.3', margin: '0 0 16px' }}>
            Gerencie sua clínica com eficiência
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '16px', lineHeight: '1.6', margin: 0 }}>
            Agenda, prontuários, financeiro e muito mais em um só lugar.
          </p>

          {/* Features */}
          <div style={{ marginTop: '40px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {[
              { icon: '📅', text: 'Agenda inteligente e controle de consultas' },
              { icon: '💊', text: 'Prontuário eletrônico completo' },
              { icon: '💰', text: 'Gestão financeira integrada' },
              { icon: '📊', text: 'Relatórios e indicadores em tempo real' },
              { icon: '💬', text: 'Captura de Leads pelo WhatsApp' },
              
            ].map(f => (
              <div key={f.text} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: '36px', height: '36px', borderRadius: '8px',
                  backgroundColor: 'rgba(255,255,255,0.12)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '16px', flexShrink: 0,
                }}>
                  {f.icon}
                </div>
                <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px' }}>{f.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Rodapé do painel */}
        <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '12px', margin: 0, position: 'relative', zIndex: 1 }}>
          © {new Date().getFullYear()} FluxoClínica. Todos os direitos reservados.
        </p>
      </div>

      {/* ── Painel direito — formulário ── */}
      <div style={{
        width: '100%',
        maxWidth: '480px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '48px 32px',
        backgroundColor: '#fff',
        boxShadow: '-4px 0 24px rgba(0,0,0,0.06)',
      }}>

        {/* Logo mobile (visível apenas em telas pequenas) */}
        <div style={{ marginBottom: '32px', textAlign: 'center' }} className="login-logo-mobile">
          <img src={logoImage} alt="Logo Clínica" style={{ maxHeight: '80px', objectFit: 'contain' }} />
        </div>

        {/* Cabeçalho do form */}
        <div style={{ width: '100%', maxWidth: '360px', marginBottom: '32px' }}>
          <h1 style={{ margin: '0 0 8px', fontSize: '26px', fontWeight: '700', color: '#111827' }}>
            Bem-vindo de volta 👋
          </h1>
          <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
            Faça login para acessar o painel da sua clínica.
          </p>
        </div>

        {/* Formulário */}
        <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: '360px' }}>

          {/* Erro */}
          {error && (
            <div style={{
              display: 'flex', alignItems: 'flex-start', gap: '10px',
              padding: '12px 14px',
              backgroundColor: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '10px',
              marginBottom: '20px',
            }}>
              <span style={{ fontSize: '16px', flexShrink: 0 }}>⚠️</span>
              <p style={{ margin: 0, fontSize: '13px', color: '#991b1b', lineHeight: '1.5' }}>{error}</p>
            </div>
          )}

          {/* Campo Email */}
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>
              Email
            </label>
            <div style={{ position: 'relative' }}>
              <span style={{
                position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)',
                fontSize: '16px', pointerEvents: 'none',
              }}>
                ✉️
              </span>
              <input
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                disabled={isLoading}
                style={{
                  width: '100%',
                  padding: '11px 14px 11px 40px',
                  border: '1.5px solid #e5e7eb',
                  borderRadius: '10px',
                  fontSize: '14px',
                  color: '#111827',
                  backgroundColor: '#fff',
                  outline: 'none',
                  transition: 'border-color 0.15s, box-shadow 0.15s',
                  fontFamily: 'inherit',
                  boxSizing: 'border-box',
                }}
                onFocus={e => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.1)'; }}
                onBlur={e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; }}
              />
            </div>
          </div>

          {/* Campo Senha */}
          <div style={{ marginBottom: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
              <label style={{ fontSize: '13px', fontWeight: '600', color: '#374151' }}>
                Senha
              </label>
            </div>
            <div style={{ position: 'relative' }}>
              <span style={{
                position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)',
                fontSize: '16px', pointerEvents: 'none',
              }}>
                🔒
              </span>
              <input
                type={showPass ? 'text' : 'password'}
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                disabled={isLoading}
                style={{
                  width: '100%',
                  padding: '11px 44px 11px 40px',
                  border: '1.5px solid #e5e7eb',
                  borderRadius: '10px',
                  fontSize: '14px',
                  color: '#111827',
                  backgroundColor: '#fff',
                  outline: 'none',
                  transition: 'border-color 0.15s, box-shadow 0.15s',
                  fontFamily: 'inherit',
                  boxSizing: 'border-box',
                }}
                onFocus={e => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.1)'; }}
                onBlur={e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; }}
              />
              {/* Toggle mostrar/ocultar senha */}
              <button
                type="button"
                onClick={() => setShowPass(p => !p)}
                style={{
                  position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
                  background: 'none', border: 'none', cursor: 'pointer',
                  fontSize: '16px', padding: '2px', lineHeight: 1,
                  color: '#9ca3af',
                }}
                title={showPass ? 'Ocultar senha' : 'Mostrar senha'}
              >
                {showPass ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          {/* Botão de login */}
          <button
            type="submit"
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px',
              background: isLoading
                ? '#93c5fd'
                : 'linear-gradient(135deg, #3b82f6, #2563eb)',
              color: '#fff',
              border: 'none',
              borderRadius: '10px',
              fontSize: '15px',
              fontWeight: '700',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              transition: 'all 0.2s',
              fontFamily: 'inherit',
              boxShadow: isLoading ? 'none' : '0 4px 14px rgba(59,130,246,0.4)',
              letterSpacing: '0.01em',
            }}
            onMouseEnter={e => { if (!isLoading) { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(59,130,246,0.5)'; } }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = isLoading ? 'none' : '0 4px 14px rgba(59,130,246,0.4)'; }}
          >
            {isLoading ? (
              <>
                <span style={{
                  width: '18px', height: '18px', borderRadius: '50%',
                  border: '2px solid rgba(255,255,255,0.35)',
                  borderTopColor: '#fff',
                  animation: 'spin 0.7s linear infinite',
                  display: 'inline-block', flexShrink: 0,
                }} />
                Entrando...
              </>
            ) : (
              <>
                Entrar
                <span style={{ fontSize: '16px' }}>→</span>
              </>
            )}
          </button>

          <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #e5e7eb' }}>
            <button type="button" onClick={() => navigate('/representante')} disabled={isLoading}
              style={{ width: '100%', padding: '12px 16px', border: '1px solid #bbdfce', borderRadius: '10px', background: '#f0faf5', color: '#166534', fontSize: '14px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
              Sou representante
            </button>
            <p style={{ margin: '10px 0 0', textAlign: 'center', fontSize: '12px', color: '#6b7280' }}>
              Acesse o portal com a empresa, o e-mail e a senha fornecidos pelo responsável.
            </p>
          </div>

          {/* Rodapé do form */}
          <p style={{ textAlign: 'center', marginTop: '24px', fontSize: '12px', color: '#9ca3af' }}>
            © {new Date().getFullYear()} FluxoClínica · Todos os direitos reservados.
          </p>
        </form>
      </div>

      {/* ── CSS responsivo ── */}
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Mostra o painel esquerdo em telas grandes */
        @media (min-width: 768px) {
          .login-left-panel {
            display: flex !important;
          }
          .login-logo-mobile {
            display: none !important;
          }
        }

        /* Em mobile, o painel direito ocupa tudo */
        @media (max-width: 767px) {
          .login-left-panel {
            display: none !important;
          }
          .login-logo-mobile {
            display: block !important;
          }
        }

        input:-webkit-autofill {
          -webkit-box-shadow: 0 0 0 30px white inset !important;
          -webkit-text-fill-color: #111827 !important;
        }
      `}</style>
    </div>
  );
};

export default Login;
